import {
    CORE_LOAD_EVENTTYPE_REQUEST,
    CORE_LOAD_EVENTTYPE_SUCCESS,

    CORE_LOAD_EVENTTYPE_INFO_REQUEST,
    CORE_LOAD_EVENTTYPE_INFO_SUCCESS,

    CORE_SEARCH_EVENTTYPE_REQUEST,
    CORE_SEARCH_EVENTTYPE_SUCCESS,
} from '../../types'

const initialState = []
export default {
    allEventType: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_EVENTTYPE_REQUEST:
            case CORE_SEARCH_EVENTTYPE_REQUEST:
                return initialState
            case CORE_LOAD_EVENTTYPE_SUCCESS:
            case CORE_SEARCH_EVENTTYPE_SUCCESS:
                return action.payload
            default:
                return state
        }
    },
    eventType: (state = {}, action) => {
        switch (action.type) {
            case CORE_LOAD_EVENTTYPE_INFO_REQUEST:
                return {}
            case CORE_LOAD_EVENTTYPE_INFO_SUCCESS:
                return action.payload
            default:
                return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/features/eventType/reducer.js